const autoNgTemplateLoaderTemplate1 = require('./kubernetes-app-git-form.html');

import angular from 'angular';
import controller from './kubernetes-app-git-form.controller';

const kubernetesAppGitForm = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    namespace: '<',
    stack: '<',
  },
};

angular.module('shbdeployer.app').component('kubernetesAppGitForm', kubernetesAppGitForm);
